import { TableArrowUpIcon } from './TableArrowUpIcon';

/**
 * author: Michael Irigoyen
 * id 2A9EE017-5EDD-4A0B-A531-E552D4C8AB66
 * name table-arrow-up
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-arrow-up.svg
 * tags
 */
export const TableUploadIcon = TableArrowUpIcon;
export default TableUploadIcon